import { render, staticRenderFns } from "./location.vue?vue&type=template&id=0032d61f"
import script from "./location.vue?vue&type=script&lang=ts"
export * from "./location.vue?vue&type=script&lang=ts"
import style0 from "./location.vue?vue&type=style&index=0&id=0032d61f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports